import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'cigna-dialog-legal-disclaimer',
  templateUrl: './dialog-legal-disclaimer.component.html',
  styleUrls: ['./dialog-legal-disclaimer.component.scss'],
})
export class DialogLegalDisclaimerComponent {
  constructor(public dialogRef: MatDialogRef<DialogLegalDisclaimerComponent>) {}
}
